module.exports = __webpack_public_path__ + "img/chr_ts_6.b5af57d6.png";